import api from '../config/axios';

export const getStudents = (params) => api.get('/students', { params });
export const getStudentById = (id) => api.get(`/students/${id}`);
export const createStudent = (data) => api.post('/students', data);
export const updateStudent = (id, data) => api.put(`/students/${id}`, data);
export const updateStudentStatus = (id, data) => api.patch(`/students/${id}/status`, data);
export const deleteStudent = (id) => api.delete(`/students/${id}`);
export const searchStudents = (params) => api.get('/students/search', { params });
export const getStudentTimeline = (id) => api.get(`/students/${id}/timeline`);
export const getContactRemarks = (studentId) => api.get(`/students/${studentId}/remarks`);
export const addContactRemark = (studentId, data) => api.post(`/students/${studentId}/remarks`, data);
export const getPreviousLoans = (studentId) => api.get(`/students/${studentId}/previous-loans`);
export const addPreviousLoan = (studentId, data) => api.post(`/students/${studentId}/previous-loans`, data);
export const updatePreviousLoan = (studentId, loanId, data) => api.put(`/students/${studentId}/previous-loans/${loanId}`, data);
export const deletePreviousLoan = (studentId, loanId) => api.delete(`/students/${studentId}/previous-loans/${loanId}`);
export const updateCibilScores = (studentId, data) => api.put(`/students/${studentId}/cibil-scores`, data);
export const getApplicationForm = (studentId) => api.get(`/students/${studentId}/application`);
export const saveApplicationForm = (studentId, data) => api.put(`/students/${studentId}/application`, data);
